import { IFormDefinition } from "@entaconsulting/form";
import { debounce } from "lodash";
import { useLayoutEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setIsAsyncRenderForm } from "../store/editorSlice";

const DEBOUNCE_TIME_MS: number = 500;

const useDebouncedFormDefinition = () => {
  const dispatch = useAppDispatch();
  const [formDefinition, setFormDefinition] = useState<IFormDefinition>({
    schema: {},
    layout: { elements: [] },
    options: {},
  });

  const formDefinitionPreview = useAppSelector(
    (state) => state.developer.edit.editor.formDefinitionPreview
  );

  const isAsyncRenderForm = useAppSelector(
    (state) => state.developer.edit.editor.isAsyncRenderForm
  );

  const debouncedUpdate = useMemo(() => {
    return debounce(() => {
      dispatch(setIsAsyncRenderForm(false));
    }, DEBOUNCE_TIME_MS);
  }, [dispatch]);

  useLayoutEffect(() => {
    if (isAsyncRenderForm) {
      debouncedUpdate();
    } else {
      setFormDefinition(formDefinitionPreview);
    }
  }, [debouncedUpdate, formDefinitionPreview, isAsyncRenderForm]);

  return formDefinition;
};

export default useDebouncedFormDefinition;
